<template>
  <right-banner-template :title="entry">
    <div class="detail">
      <p class="title">{{ title }}</p>
      <div v-html="content" class="ql-editor"></div>
      <!-- <p class="content">{{ content }}</p> -->
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['entry', 'title', 'content'],
  computed: {
    entryFill () {
      if (!this.entry) return this.title
      return this.entry
    }
  }
}
</script>

<style scoped>
  .ql-editor{
    height: 100%;
  }
  .detail {
    margin-bottom: 40px;
  }

  .detail .title {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }

  .detail .content {
    margin-top: 30px;
  }
</style>
